import React, { useEffect } from "react";

import "./paymentFailure.m.css";

const PaymentFailure = () => {
  useEffect(() => {
    window.dataLayer.push({
      event: "payment_failed",
      failure_reason: "something went wrong!, please try other payment option.",
    });
  }, []);

  return (
    <div styleName="wrapper">
      <div styleName="header-wrapper">
        <span styleName="header-title">Payment Failed</span>
      </div>

      <div styleName="content">
        <span styleName="failure-msg">Oops! Your transaction could not be processed.!</span>
        <span styleName="title1">Try making a payment through Juspay.</span>
        <div styleName="title2">
          Unable to make a payment? write to us at &nbsp;
          <a href="mailto:membership@thequint.com">membership@thequint.com</a>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
